import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import Iconify from '../../../components/iconify';
import DeclareForm from './DeclareForm';
import api from '../../../api';
import { useDispatch } from 'react-redux';
import { loadingStartAction, loadingStopAction } from 'src/redux/actions/loadingActions';

export default function UpdateResultModal({ selectedGame }) {
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const dispatch = useDispatch();
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const refundHandler = async () => {
    dispatch(loadingStartAction());
    const reqBody = {
      game_id: selectedGame.master_game_id,
      master_game_created_date: selectedGame.game_update_at,
    };
    await api.post('/declare-results/refund-points', reqBody);
    dispatch(loadingStopAction());

    window.location.reload();
  };

  return (
    <div>
      {selectedGame ? (
        <Button
          disabled={(!selectedGame?.is_open_pending && !selectedGame?.is_close_pending) || selectedGame?.is_refunded}
          onClick={handleClickOpen}
          variant="contained"
          startIcon={<Iconify icon="eva:plus-fill" />}
        >
          Declare Result
        </Button>
      ) : (
        <Button onClick={handleClickOpen} variant="contained" startIcon={<Iconify icon="eva:plus-fill" />}>
          Declare Result
        </Button>
      )}

      {selectedGame && (
        <Button
          disabled={(!selectedGame?.is_open_pending && !selectedGame?.is_close_pending) || selectedGame?.is_refunded}
          color="error"
          style={{
            marginLeft: 10,
          }}
          onClick={refundHandler}
          variant="contained"
        >
          REFUND
        </Button>
      )}

      <Dialog
        fullWidth={true}
        maxWidth={'md'}
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">Fill Details Carefully</DialogTitle>
        <DialogContent>
          <DeclareForm handleClose={handleClose} selectedGame={selectedGame} />
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Skip Now
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
